import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { Geolocation } from '@ionic-native/geolocation/ngx';
import { IonicModule } from '@ionic/angular';

import { EditarInventarioPage } from './editar-inventario.page';

const routes: Routes = [
  {
    path: '',
    component: EditarInventarioPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  providers:[Geolocation],
  declarations: [EditarInventarioPage]
})
export class EditarInventarioPageModule {}
